import { createColumnHelper } from "@tanstack/react-table";
import {
  LocationPartyEntryDetails,
  PartyDisplayDetails,
  PartyEntryDetails,
} from "../../interfaces/app_types";
import { hexToRgba } from "../funcs/common";
import LocationPartyEditDeleteButton from "../../components/inventory/LocationPartyEditDeleteButton";
const columnHelper = createColumnHelper<LocationPartyEntryDetails>();
const partyColumnHelper = createColumnHelper<PartyDisplayDetails>();

export const locationColumns = [
  columnHelper.accessor((row) => row?.value, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.label, {
    header: "Name",
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor((row) => row?.color, {
    id: "Color",
    cell: (info) => (
      <div
        className="color-status"
        style={{ backgroundColor: hexToRgba(info.getValue()) }}
      >
        {info.getValue()}
      </div>
    ),
  }),
  columnHelper.accessor((row) => row?.value, {
    id: "Edit",
    enableColumnFilter: false,
    cell: (info) => (
      <LocationPartyEditDeleteButton
        part_id={info.getValue()}
        btnType="edit"
        isLocation={true}
      />
    ),
  }),
  columnHelper.accessor((row) => row?.value, {
    id: "Delete",
    enableColumnFilter: false,
    cell: (info) => (
      <LocationPartyEditDeleteButton
        part_id={info.getValue()}
        btnType="delete"
        isLocation={true}
      />
    ),
  }),
];

export const partyColumns = [
  partyColumnHelper.accessor((row) => row?.value, {
    header: "ID",
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
  }),
  partyColumnHelper.accessor((row) => row?.label, {
    header: "Name",
    cell: (info) => info.getValue(),
  }),
  partyColumnHelper.accessor((row) => row?.party_type, {
    header: "Type",
    cell: (info) => info.getValue().toUpperCase(),
  }),
  partyColumnHelper.accessor((row) => row?.color, {
    id: "Color",
    cell: (info) => (
      <div
        className="color-status"
        style={{ backgroundColor: hexToRgba(info.getValue()) }}
      >
        {info.getValue()}
      </div>
    ),
  }),
  partyColumnHelper.accessor((row) => row?.value, {
    id: "Edit",
    enableColumnFilter: false,
    cell: (info) => (
      <LocationPartyEditDeleteButton
        part_id={info.getValue()}
        btnType="edit"
        isLocation={false}
      />
    ),
  }),
  partyColumnHelper.accessor((row) => row?.value, {
    id: "Delete",
    enableColumnFilter: false,
    cell: (info) => (
      <LocationPartyEditDeleteButton
        part_id={info.getValue()}
        btnType="delete"
        isLocation={false}
      />
    ),
  }),
];
